<div class="header">
  <div class="title">Add Lease</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="propertyTenantForm">
  <!-- Subject -->
  @if (isPropertyLease) {
    <div class="flex flex-col mt-3 gt-xs:flex-row">
      <mat-form-field class="flex-auto subject">
        <mat-label>Lease Name</mat-label>
        <input matInput [formControlName]="'name'" />
      </mat-form-field>
    </div>
  }
  <div class="flex flex-col mt-3 gt-xs:flex-row">
    <mat-form-field class="flex-auto subject">
      <mat-label>Lease Start Date</mat-label>
      <input
        matInput
        [matDatepicker]="lcdPicker"
        [formControlName]="'lease_start_date'"
        [placeholder]="'Lease Start Date'"
      />
      <mat-datepicker-toggle matSuffix [for]="lcdPicker"> </mat-datepicker-toggle>
      <mat-datepicker #lcdPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="flex flex-col mt-3 gt-xs:flex-row">
    <mat-form-field class="flex-auto subject">
      <mat-label>Lease End Date</mat-label>
      <input
        matInput
        [matDatepicker]="ledPicker"
        [formControlName]="'lease_end_date'"
        [placeholder]="'Lease End Date'"
      />
      <mat-datepicker-toggle matSuffix [for]="ledPicker"> </mat-datepicker-toggle>
      <mat-datepicker #ledPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="flex flex-col mt-3 gt-xs:flex-row">
    <mat-form-field class="flex-auto subject">
      <mat-label>Base Monthly Rent</mat-label>
      <input matInput currencyMask [formControlName]="'base_monthly_rent'" [options]="currencyMaskOptions" />
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting"></div>

    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        [disabled]="isSaveBtnDisabled"
        data-cy="add-property-unit-save"
        DebounceClick
        (debounceLoading)="isDebounceLoading($event)"
        (debounceClick)="save()"
      >
        <span *ngIf="!propertyTenantForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="propertyTenantForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
